// AUTO-GENERATED from Firestore dump. Do not edit by hand.
// Source: scripts/build-static-config.mjs (config version 23)

import type { TvmFormDefinition } from "../types";

const form: TvmFormDefinition = {
	"formula": {
		"distanceBtWindTips": "distanceBtWindTips",
		"gatesSweepArea": "((((((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength)*(sqrt(((netLength+windLength+malletasLength+pieDeGalloLength)**2)-(((((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength)/2)**2))))/2))*2",
		"__cond": {
			"distanceBtWindTips>=80&&distanceBtWindTips<=90": "#ffcdd2",
			"distanceBtWindTips>=41&&distanceBtWindTips<=55": "#fff9c4",
			"distanceBtWindTips>=56&&distanceBtWindTips<=68": "#c8e6c9",
			"distanceBtWindTips>=20&&distanceBtWindTips<=40": "#ffcdd2",
			"distanceBtWindTips>=69&&distanceBtWindTips<=79": "#fff9c4"
		},
		"netOpening": "(distanceBtWindTips/100)*headropeLength",
		"filteredWaterVolume": "((trawlSpeed*0.516)*(((distanceBtWindTips/100)*headropeLength)*verticalNetOpening*0.75))*2",
		"strikeAngle": "asin(((((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength)/2)/(netLength+windLength+malletasLength+pieDeGalloLength))",
		"doorOpening": "((netLength+windLength+malletasLength+pieDeGalloLength)*((distanceBtWindTips/100)*headropeLength))/netLength"
	},
	"hints": {
		"htmlDef": "<div style=\"display: block; margin-bottom: 1rem; font-family: Helvetica; font-size: 20px;\">     <div>     <div style=\"width: 2rem;height: 1rem;background-color: #c8e6c9;border: 1px solid;display: inline-block;margin-right: 1rem;\"><br></div>     <span style=\"line-height: 1.5; \">{{form_trawl_systems_hints_p1}}</span>           </div>     <div>     <div style=\"width: 2rem;height: 1rem;background-color: #fff9c4;border: 1px solid;display: inline-block;margin-right: 1rem;\"><br></div>     <span style=\"line-height: 1.5; \">{{form_trawl_systems_hints_p2}}</span>        </div>     <div>     <div style=\"width: 2rem;height: 1rem;background-color: #ffcdd2;border: 1px solid;display: inline-block;margin-right: 1rem;\"><br></div>     <span style=\"line-height: 1.5; \">{{form_trawl_systems_hints_p3}}<br>        </div>     <p><strong>{{form_trawl_systems_hints_p4}}</strong></p>     <ol>     <li>{{form_trawl_systems_hints_p5}}</li>     <li>{{form_trawl_systems_hints_p6}}</li>     <li>{{form_trawl_systems_hints_p7}}</li>     <li>{{form_trawl_systems_hints_p8}}</li>     <li>{{form_trawl_systems_hints_p9}}</li>     <li>{{form_trawl_systems_hints_p10}}</li>     <li>{{form_trawl_systems_hints_p11}}</li>     <li>{{form_trawl_systems_hints_p12}}</li>     <li>{{form_trawl_systems_hints_p13}}<br></li>     <br>       </ol>     <p><strong>{{form_trawl_systems_hints_p14}}</strong></p>     <ol>     <li>{{form_trawl_systems_hints_p15}}</li>     <li>{{form_trawl_systems_hints_p16}}</li>     <li>{{form_trawl_systems_hints_p17}}</li>     <li>{{form_trawl_systems_hints_p18}}</li>     <li>{{form_trawl_systems_hints_p19}}</li>     <li>{{form_trawl_systems_hints_p20}}</li>     <li>{{form_trawl_systems_hints_p21}}</li>     <li>{{form_trawl_systems_hints_p22}}</li>     <li>{{form_trawl_systems_hints_p23}}</li>     </ol> </div>",
		"title": "Tangoneros"
	},
	"fields": {
		"verticalNetOpening": {
			"type": "INPUT",
			"label": "$form_trawl_systems_vertical_aperture",
			"index": 6,
			"inputType": "number",
			"value": 0,
			"name": "verticalNetOpening"
		},
		"netLength": {
			"value": 0,
			"name": "netLength",
			"inputType": "number",
			"type": "INPUT",
			"label": "$form_trawl_systems_net_long",
			"index": 1
		},
		"distanceBtWindTips": {
			"value": 10,
			"name": "distanceBtWindTips",
			"type": "INPUT",
			"index": 7,
			"label": "$form_trawl_systems_headrope_aperture",
			"inputType": "range-bar",
			"range": {
				"max": 90,
				"step": 1,
				"min": 10
			}
		},
		"trawlSpeed": {
			"inputType": "number",
			"type": "INPUT",
			"index": 0,
			"label": "$form_trawl_systems_speed",
			"value": 0,
			"name": "trawlSpeed"
		},
		"malletasLength": {
			"value": 0,
			"name": "malletasLength",
			"inputType": "number",
			"type": "INPUT",
			"label": "$form_trawl_systems_sweepline",
			"index": 4
		},
		"pieDeGalloLength": {
			"name": "pieDeGalloLength",
			"value": 0,
			"label": "$form_trawl_systems_backstrop_length",
			"index": 5,
			"type": "INPUT",
			"inputType": "number"
		},
		"windLength": {
			"inputType": "number",
			"type": "INPUT",
			"index": 3,
			"label": "$form_trawl_systems_bridle_length",
			"value": 0,
			"name": "windLength"
		},
		"headropeLength": {
			"inputType": "number",
			"type": "INPUT",
			"index": 2,
			"label": "$form_trawl_systems_headrope_length",
			"value": 0,
			"name": "headropeLength"
		}
	}
};

export const tangonero = form;
